<template>
  <div class="status-card">
    <div class="status-card__top">
      <div class="status-card__top__circle-chart">
        <ProgressCircle
          v-if="data.progressType === 'line'"
          :unique="data.circleUnique"
          :value="data.progress"
          :colorStart="data.colorStart"
          :colorStop="data.colorStop"
          :textColor="textColor"
        />
        <ProgressWave
          v-else
          :unique="data.circleUnique"
          :value="data.progress"
          :textColor="textColor"
          :circleText="data.circleText"
        />
      </div>
      <div class="status-card__top__description">
        <div class="status-card__top__description__name">{{data.name}}</div>
        <div class="status-card__top__description__text" :style="{color: data.color}">{{data.text}}</div>
      </div>
      <div
        v-if="data.progressType === 'line'"
        class="status-card__top__value"
      >{{`${data.progress.toFixed(1)}%`}}</div>
      <div v-else class="status-card__top__value wave">
        <div class="status-card__top__value__up">
          <img :src="up_img" alt="上传图标" />
          {{data.up}}k
        </div>
        <div class="status-card__top__value__down">
          <img :src="down_img" alt="下载图标" />
          {{data.down}}k
        </div>
      </div>
    </div>
    <div class="status-card__bottom">
      <EchartsVue
        v-if="option !== null"
        :id="data.circleUnique"
        width="100%"
        height="4.375rem"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import ProgressCircle from "@/components/common/ProgressCircle";
import ProgressWave from "@/components/common/ProgressWave";
import EchartsVue from "@/components/common/EchartsVue";
import DefaultOptions from "@/utils/EchartsDefaultOptions.js";
import up_img from "@/assets/images/upload.png";
import down_img from "@/assets/images/download.png";

export default {
  name: "StatusCard",
  data() {
    return {
      textColor: "#ffffff",
      width: 60,
      height: 60,
      up_img,
      down_img
    };
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    optionColorArray: function() {
      let colorArray = [];
      switch (this.data.circleUnique) {
        case "cpu":
          colorArray = [["#FF5400", "rgb(255,84,0)", "rgb(0,0,0)"]];
          break;
        case "ram":
          colorArray = [["#EFAF47", "rgb(239,175,71)", "rgb(0,0,0)"]];
          break;
        case "disk":
          colorArray = [["#4E71E6", "rgb(78,113,230)", "rgb(0,0,0)"]];
          break;
        case "internet":
          colorArray = [
            ["#4E71E6", "rgb(78,113,230)", "rgb(26,24,59)"],
            ["#01B377", "rgb(1,49,32)", "rgb(0,114,73)"]
          ];
          break;
        default:
          break;
      }
      return colorArray;
    },
    option: function() {
      let _option = Object.assign({}, DefaultOptions.areaLine);
      let dataArray = this.data.history;
      // debugger;
      if (dataArray && dataArray[0].length) {
        _option.series = dataArray.map((data, index) => {
          return {
            data,
            type: "line",
            lineStyle: {
              width: 1,
              color: this.optionColorArray[index][0]
            },
            areaStyle: {
              opacity: 0.2,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: this.optionColorArray[index][1] // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: this.optionColorArray[index][2] // 100% 处的颜色
                  }
                ]
              }
            },
            symbol: "none"
          };
        });

        _option.xAxis = {
          type: "category",
          show: true,
          splitNumber: 3,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: this.optionColorArray[0][0],
              opacity: 0.06
            }
          },
          data: dataArray[0].map((_, index) => `分类${index}`)
        };

        _option.yAxis = {
          type: "value",
          show: true,
          splitNumber: 3,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: this.optionColorArray[0][0],
              opacity: 0.06
            }
          }
        };

        if (_option.series.length === 2) {
          _option.xAxis.axisLine = {
            show: true,
            lineStyle: {
              color: this.optionColorArray[1][0],
              opacity: 0.3
            }
          };
        }
        return _option;
      } else {
        return null;
      }
    }
  },
  mounted() {

  },
  components: {
    ProgressCircle,
    EchartsVue,
    ProgressWave
  }
};
</script>

<style lang="less" scoped>
.status-card {
  display: flex;
  flex-direction: column;
  width: 15.64rem;
  height: 10rem;
  background-color: #262934;
  border-radius: 0.38rem;
  padding: 0.63rem 0 0 0;
  box-sizing: border-box;

  &__top {
    height: 3.75rem;
    display: flex;
    padding: 0 0.56rem;

    &__circle-chart {
      width: 3.75rem;
    }

    &__description {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 3.75rem;
      margin-left: 0.63rem;

      &__name {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 0.88rem;
        color: #ffffff;
      }

      &__text {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 0.75rem;
      }
    }

    &__value {
      width: 5rem;
      padding-top: 0.5rem;
      text-align: right;
      font-size: 0.88rem;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-end;

      &.wave {
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
      }

      &__up {
        font-size: 0.75rem;
        color: rgba(32, 134, 251, 1);
      }

      &__down {
        margin-top: 0.53rem;
        font-size: 0.75rem;
        color: rgba(1, 179, 119, 1);
      }
    }
  }

  &__bottom {
    flex: 1;
    margin-top: 1.25rem;
  }
}
</style>